var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"clearable":"","placeholder":"Wybierz tag"},model:{value:(_vm.value.tag),callback:function ($$v) {_vm.$set(_vm.value, "tag", $$v)},expression:"value.tag"}},_vm._l((_vm.availableTagOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }